import React from "react";

export const Loading = ({
  className,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`${className} bg-gray-100 rounded animate-pulse`} {...rest} />
);

export const LoadingFilters = () => (
  <div className="mt-2 px-3">
    <div className="grid grid-cols-2 gap-2 mb-4">
      <div className="flex justify-center border-b-2 border-gray-100 pb-4">
        <Loading className="h-6 w-24" />
      </div>
      <div className="flex justify-center border-b border-gray-100 pb-4">
        <Loading className="h-6 w-24" />
      </div>
    </div>
    <div className="py-2 border-b border-gray-100 flex justify-between">
      <Loading className="h-6 w-24" />
      <Loading className="h-6 w-6" />
    </div>
    <div className="grid gap-2 py-2 border-b border-gray-100">
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-24" />
      </div>
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-28" />
      </div>
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-20" />
      </div>
    </div>
    <div className="py-2 border-b border-gray-100 flex justify-between">
      <Loading className="h-6 w-32" />
      <Loading className="h-6 w-6" />
    </div>
    <div className="py-2 border-b border-gray-100 flex justify-between">
      <Loading className="h-6 w-16" />
      <Loading className="h-6 w-6" />
    </div>
    <div className="grid gap-2 py-2 border-b border-gray-100">
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-24" />
      </div>
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-28" />
      </div>
      <div className="flex justify-start items-center gap-2">
        <Loading className="h-5 w-5" />
        <Loading className="h-6 w-20" />
      </div>
    </div>
  </div>
);
